import './proxima_nova_bold.otf';
import './proxima_nova_regular.otf';
import './proxima_nova_light.otf';
